export enum LumpSumAmountsCoveredOptions {
  Hide = 0,
  ShowCovered = 1,
  ShowSettlementOnLastMonth = 2,
  ShowSettlementOnNextPeriod = 3,
  ShowSettlementOnEveryMonth = 4,
}
